export const color = {
	system: {
		error: '#F05050',
		warning: '#FFBD4A',
		info: '#35B8E0',
		infoWithTranparenci: 'rgba(53, 127, 224, 0.5)',
		success: '#10C369',
		successWithTranparenci: 'rgba(16, 195, 105, 0.5)',
		font: '#291F17',
		backGroundWithTransparenci: 'rgb(108, 117, 125,0.5)'
	},

	interface: {
		white: '#FFFFFF',
		black: '#000000 ',
		blackMofiq: '#1D1D1D ',
		blackMofiq2: '#3d3d3d ',
		pinkMofiq: '#ff2d97 ',
		lightGreen: '#20f0f0',
		green: '#006946',
		green2: '#078A81',
		red: '#f44336',
		lightGray: '#6C757D',
		lightGray2: '#CED4DA',
		lightGray3: '#f8f8f8',
		lightGray4: '#EBEFF2',
		lightGray5: '#C8CBD3',
		lightGray6: '#F5F5F5',
		lightGray7: '#d7d7d7',
		backgroundGray: '#ebeff2',
		darkgray: '#343A40',
		darkgray2: '#98A6AD',
		darkgray3: '#4B5055',
		darkgray4: '#8F8F8F',
		darkgray5: '#8E8E8E',
		blue: '#1213B0',
		blue1: '#00427C',
		lightBlue: '#5B5CE3',
		lightBlue2: '#71B6F9',
		backgroundHome: '#F2F2F7',
		vtexPink: '#e31c58',
		onDragColor: '#90EE90',
		onDragColor2: '#71B6F9',
		purple: '#684084'
	},
	//exemplo
	auxiliary: {
		greenMoss: '#50A200',
		greenFluor: '#57DE9E',
		greenBaby: '#57DE9E',
		mustard: '#DEA100',
		coral: '#FA562D',
		lightCoral: '#FF7B24',
		darkCoral: '#B93B00',
		brownCoral: '#B93B00',
		brownMoss: '#857535',
		blueBic: '#50A200',
		blueSky: '#32C8ED',
		blueWater: '#1677B8',
		bluePurple: '#7080E0',
		red: '#F05050',
		green: '#10C469',
		yellow: '#FFBD4A',
		pink: '#FE89CB',
		blue: '#188AE2',
		purple: '#5B69BC',
		lightGreen: '#20f0f0'
	}
};
